var getRadiumStyleState = function getRadiumStyleState(component) {
  return component._lastRadiumState || component.state && component.state._radiumStyleState || {};
};

export default getRadiumStyleState;


//////////////////
// WEBPACK FOOTER
// ../node_modules/radium/es/get-radium-style-state.js
// module id = 440
// module chunks = 66